import useTranslation from 'customHooks/translate';
import CurrencyFlag from 'react-currency-flags';

interface SummaryItem {
  currency: string;
  incomesTotal: string;
  invoiceAmount: string;
  remainBalance: number;
  incomesTotalDefault: number;
  defaultCurrency?: string;
}

interface IProps {
  title: string;
  summaryData: SummaryItem[];
}
export const ReportsTotalViewIncome = ({ title, summaryData }: IProps) => {
  const totalIncomesDefault = summaryData
    ?.map((s) => s.incomesTotalDefault)
    .reduce((total, value) => total + value, 0);

  const translation = useTranslation();

  const defaultCurrency = summaryData?.[0]?.defaultCurrency || '';

  return (
    <div className="flex flex-col gap-[10px] p-[16px]">
      <div className="flex h-max flex-col justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">{title}</p>
        {summaryData?.map((summary, index) => (
          <div
            className="flex items-center gap-[4px] text-[16px] font-medium text-[#1D1D1D]"
            key={index}
          >
            <CurrencyFlag
              className="currency-flag"
              currency={summary.currency}
            />
            <span>
              {summary.invoiceAmount
                ? new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(parseFloat(summary.invoiceAmount) || 0)
                : new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(parseFloat(summary.incomesTotal) || 0)}
            </span>
            <span> {summary.currency}</span>
          </div>
        ))}
      </div>
      <div className="flex h-max flex-col justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.reports.TotalIncomes}
        </p>
        <div className="flex items-center gap-[4px]">
          <CurrencyFlag className="currency-flag" currency={defaultCurrency} />
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            {totalIncomesDefault
              ? new Intl.NumberFormat('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(totalIncomesDefault)
              : ''}{' '}
            {defaultCurrency}
          </p>
        </div>
      </div>
    </div>
  );
};
